import { Controller } from '@hotwired/stimulus';

export default class AutocompleteSubmitController extends Controller<HTMLFormElement> {
  connect() {
    if (!(this.element instanceof HTMLFormElement)) {
      throw new Error('AutocompleteSubmitController is only meant to be used with a form!');
    }
  }

  submit(event: HTMLElementEventMap['autocomplete:change']) {
    if (event.detail.value !== '') {
      this.element.submit();
    }
  }
}
